import { Access, Menu, Status, StatusChangeType, User } from "./index";
import { statusChangeCollection } from "./status-change-collection";

export class StatusChange {
    id?: number;
    title: String;
    icon: String;
    statusChangeCollection: statusChangeCollection[] = [];
    oldStatus: Status = new Status();
    newStatus: Status = new Status();
    menu: Menu = new Menu();
    permission: Menu = new Menu();
    access: Access = new Access();
    users: User[] = [];
    approvers: number = 1;
    statusChangeType: StatusChangeType = new StatusChangeType();
    status: Status = new Status();
    createdAt: Date;
    createdUser: User;
    updatedAt: Date;
    updatedUser: User;
}
